import { Component, OnInit, ViewChild } from '@angular/core';
import { CurrentUser } from '@shared/interfaces';
import { UserRoleEnum } from '@shared/enums';
import { CurrentUserService } from '@core/services';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss', './toolbar-mobile.component.scss'],
})
export class ToolbarComponent implements OnInit {
    currentUser: CurrentUser | null = null;
    roles = UserRoleEnum;

    @ViewChild('profileMenu') overlay: OverlayPanel | null = null;

    constructor(private currentUserService: CurrentUserService) {
        this.currentUser = this.currentUserService.getCurrentUser();
        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
        });
    }

    ngOnInit(): void {
        this.currentUser = this.currentUserService.getCurrentUser();
    }

    hideOverlay(): void {
        this.overlay?.hide();
    }
}
